export const filterLiveScoreData = (source) => {
  if (!source) return null;

  return {
    homeScore: source.homeScore,
    awayScore: source.awayScore,
    homeYellow: source.homeYellow,
    homeRed: source.homeRed,
    awayYellow: source.awayYellow,
    awayRed: source.awayRed,
    homeCorner: source.homeCorner,
    awayCorner: source.awayCorner,
    status: source.status,
    minute: source.minute,
    currentMinute: source.currentMinute,
    halfStartTime: source.halfStartTime,
    var: source.var,
  };
};

export const buildMatchUpdateData = (batchData, matchId) => {
  const liveScoreData = filterLiveScoreData(batchData.liveScoreToday[matchId]);
  const liveEventData = batchData.liveEvent?.[matchId]?.events || [];
  const liveOddsData = batchData.liveOtherOdds || {};

  const hasLiveScore = liveScoreData && Object.keys(liveScoreData).length > 0;
  const hasLiveEvent = Array.isArray(liveEventData) && liveEventData.length > 0;
  const hasLiveOdds = liveOddsData && Object.keys(liveOddsData).length > 0;

  if (hasLiveScore || hasLiveEvent || hasLiveOdds) {
    const updateData = {};

    if (hasLiveScore) updateData.liveScoreToday = liveScoreData;
    if (hasLiveEvent) updateData.liveEvent = liveEventData;
    if (hasLiveOdds) updateData.liveOtherOdds = liveOddsData;

    return updateData;
  }

  return null;
};